import { useMemo } from "react";

import { BusMapData } from "../types/app.types";
import {
  TransformedHeatmapData,
  HeatmapTransformer,
} from "../helpers/heatmap_transformer";

export const useHeatmapData = (
  data: BusMapData | null,
  useMaxDensity: boolean
): TransformedHeatmapData | null => {
  return useMemo(() => {
    if (!data || !data.stops || data.stops.length === 0) {
      return null;
    }
    return HeatmapTransformer.transform(data, useMaxDensity);
  }, [data, useMaxDensity]);
};
